'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.addedToCartInfo = addedToCartInfo;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function addedToCartInfo() {
    var clazz = function AddedToCartInfo() {
        var defaults = {
            isInCart: false,
            productName: '',
            productImagePath: '',
            productQuantity: 0,
            productTotalPrice: 0,
            productTotalDiscount: 0,
            cartTotalPrice: 0,
            cartTotalDiscount: 0,
            quantityToAddForHighestDiscount: 0,
            highestDiscountPercentage: 0,
            discountName: '',
            discountImagePath: '',
            displayName: '',
            image: ''
        };

        _lodash2.default.extend(this, defaults);
    };

    _lodash2.default.extend(clazz.prototype, {});

    clazz.create = function (resource) {
        var obj = new clazz();

        obj.productName = resource.productName;
        obj.productImagePath = resource.productImagePath;
        obj.productQuantity = resource.quantity;
        obj.productTotalPrice = resource.productTotalPriceExclVat;
        obj.productTotalDiscount = resource.productTotalDiscount;
        obj.cartTotalPrice = resource.shoppingCartTotalPrice;
        obj.cartTotalDiscount = resource.shoppingCartTotalDiscountAmount ? resource.shoppingCartTotalDiscountAmount : resource.totalDiscount;
        obj.cartTotalProductQuantity = resource.shoppingCartTotalProductQuantity;
        obj.quantityToAddForHighestDiscount = resource.quantityToAddForHighestDiscount;
        obj.highestDiscountPercentage = resource.highestDiscountPercentage;
        obj.discountName = resource.discountName;
        obj.discountImagePath = resource.discountImagePath;
        obj.image = obj.discountImagePath || obj.productImagePath;
        obj.displayName = obj.discountName || obj.productName;

        return obj;
    };

    return clazz;
}


//////////////////
// WEBPACK FOOTER
// ./common/models/addedToCartInfoModel.js
// module id = 727
// module chunks = 0